export default "__VITE_ASSET__CbTERJeC__"